import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/allUniversities/AllUniversitiesHome.tsx");
